import loadable from '@loadable/component';

export const RXDTestPage = loadable(/* #__LOADABLE__ */ () => import('./RXDTestPage'));
